import axios, { AxiosResponse } from 'axios'
import { FuncionariosQueryResponse } from '../../../funcionarios/funcionarios-list/core/_models'
import { FileDownloadResponse, RelatorioQueryResponse } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const ATENDIMENTOS_URL = `${API_URL}/atendimentos`
const FUNCIONARIOS_URL = `${API_URL}/funcionarios`

export const getAtendimentosRelatorio = (query: string): Promise<RelatorioQueryResponse> => {
  return axios
    .get(`${ATENDIMENTOS_URL}/relatorio?${decodeURIComponent(query)}`)
    .then((d: AxiosResponse<RelatorioQueryResponse>) => d.data)
}

export const getPdf = (query: string): Promise<FileDownloadResponse> => {
  return axios
    .get(`${ATENDIMENTOS_URL}/relatorio/pdf?${decodeURIComponent(query)}`)
    .then((response: AxiosResponse<FileDownloadResponse>) => response.data)
}

export const getCsv = (query: string): Promise<FileDownloadResponse> => {
  return axios
    .get(`${ATENDIMENTOS_URL}/relatorio/csv?${decodeURIComponent(query)}`)
    .then((response: AxiosResponse<FileDownloadResponse>) => response.data)
}

export const getSolicitante = (query: string): Promise<FuncionariosQueryResponse> => {
  return axios
    .get(`${FUNCIONARIOS_URL}?${decodeURIComponent(query)}`)
    .then((d: AxiosResponse<FuncionariosQueryResponse>) => d.data)
}
